<template>
  <vs-dropdown vs-trigger-click vs-custom-content class="cursor-pointer">
    <slot></slot>
    <vs-dropdown-menu>
      <vs-dropdown-item
        v-for="user in filteredGuestRelationUsers"
        :key="user.userId"
        @click="$emit('onAssign', user.userId)"
      >
        {{ user.firstName + " " + user.lastName }}
      </vs-dropdown-item>
      <vs-dropdown-item
        v-if="!conversation || conversation.assignee == null || conversation.assignee.userId != userId"
        @click="$emit('onAssign', userId)"
      >
        Assign to me
      </vs-dropdown-item>
      <vs-dropdown-item v-if="!conversation || conversation.assignee != null" @click="$emit('onAssign', '')">
        Unassign
      </vs-dropdown-item>
      <vs-dropdown-item divider @click.prevent.stop>
        <vs-input
          icon-no-border
          icon="icon-search"
          icon-pack="feather"
          class="w-40 mx-0 input-rounded-full"
          placeholder="Find person"
          v-model="grUsersQuery"
        />
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    conversation: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      grUsersQuery: "",
    };
  },
  computed: {
    ...mapGetters({
      guestRelationUsers: "venues/guestRelationUsers",
      userId: "users/userId",
    }),
    filteredGuestRelationUsers() {
      if (this.grUsersQuery == "") return this.guestRelationUsers;

      return this.guestRelationUsers.filter(e => {
        const fullName = `${e.firstName} ${e.lastName}`;

        const qLower = this.grUsersQuery.toLowerCase();

        return fullName.toLowerCase().includes(qLower);
      });
    },
  },
};
</script>